import { profileConstants } from "../constants"

const deleteProfileSw = (sw: boolean) => {
  return {
    type: profileConstants.DELETE,
    profileDeleteSw: sw
  }
}

const changePasswordProfileSw = (sw: boolean) => {
  return {
    type: profileConstants.PASSWORD_CHANGE,
    profilePasswordChangeSw: sw
  }
}

export const profileActions = {
  deleteProfileSw,
  changePasswordProfileSw
}